/** @jsx jsx */
import { css, jsx } from '@emotion/core'

const mainCss = css`
  width: 100vw;
  height: 100vh;
`

const Main = () => {
  return <div css={mainCss}></div>
}

export default Main
